import type { ClinicalInsightDateRange } from "src-next/modules/clinical-insights/types/analysisTypes";
import type { LoadPhase } from "src-next/modules/clinical-insights/loadPhase";
import { processEntriesToPlans, type PlanData } from "src-next/modules/clinical-insights/transformers/processPlanEntries";
import { useQrClinicalRegisterAnalysis } from "./useQrClinicalRegisterAnalysis";

function getPlanPatientIds(records: PlanData[]): string[] {
  return records.map((p) => p.patientId);
}

interface Args {
  author: string;
  practitionerFilter: string;
  dateRange?: ClinicalInsightDateRange;
  getPractitionerName: (ref: string) => string;
  onLoadPhaseChange?: (phase: LoadPhase) => void;
  fetchEnabled?: boolean;
}

export function useTreatmentPlansAnalysisData(args: Args) {
  return useQrClinicalRegisterAnalysis<PlanData>({
    ...args,
    processEntries: processEntriesToPlans,
    getPatientIds: getPlanPatientIds,
  });
}
